import { Button, CustomInput, Form, FormGroup, Label, Modal } from "reactstrap";
import React, { useState } from "react";

import CustomButton from "components/Button";

const ExcelUploadModal = ({
    open,
    onClose,
    formError,
    onUpload,
}) => {
    const [file, setFile] = useState(null);
    const [buttonLoader, setButtonLoader] = useState(false);

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const upload = async () => {
        if (!file) {
            alert("Please select a file");
            return;
        }

        if (file && !["xls", "xlsx"].includes(file.name.split(".")[1])) {
            return;
        }
        setButtonLoader(true);
        const base64 = await convertToBase64(file);
        onUpload(base64).then(() => {
            setButtonLoader(false);
        })

    };
    return (
        <Modal zIndex={2000} centered isOpen={open} toggle={onClose}>
            <Form style={{ padding: "20px" }}>
                <FormGroup>
                    <Label for="exampleCustomFileBrowser1">File Browser</Label>
                    <CustomInput
                        type="file"
                        id="exampleCustomFileBrowser1"
                        name="customFile"
                        accept=".xlsx, .xls, .csv"
                        onChange={(e) => setFile(e.target.files[0])}
                    />
                </FormGroup>
                {file && !["xls", "xlsx"].includes(file.name.split(".")[1]) && (
                    <p className="text-center" style={{ color: "#f24822" }}>
                        Please select xls or xlsx files
                    </p>
                )}
                {formError && (
                    <p className="text-center" style={{ color: "#f24822" }}>
                        {formError}
                    </p>
                )}
                <div className="d-flex justify-content-between">
                    <Button color="link" className="btn-link-dark" onClick={onClose}>
                        Close
                    </Button>
                    <CustomButton
                        label={`${buttonLoader ? "Loading..." : "Done"}`}
                        onClick={upload}
                        disabled={!file || buttonLoader}
                    />
                </div>
            </Form>
        </Modal>
    );
};

export default ExcelUploadModal;
